export type CMSFeatureTestConfig = {
    [key: string]: string[];
};

export type hasResourceForTestTypeParams = {
    featureId: CMSFeatureId;
    habitatId: string;
    assayId: string;
};

export enum CMSFeatureId {
    SPECIES_RICHNESS = 'speciesRichness',
    EVOLUTIONARY_DIVERSITY = 'evolutionaryDiversity',
    COMMUNITY_COMPARISON = 'communityComparison',
    FISH_METRICS = 'fishMetrics',
    INVASIVES = 'invasives',
    IUCN_RED_LIST = 'iucnRedList',
    FUNGAL_FUNCTIONAL_DIVERSITY = 'fungalFunctionalDiversity',
    BACTERIAL_FUNCTIONAL_DIVERSITY = 'bacterialFunctionalDiversity',
    SPECIES_HIGHLIGHT = 'speciesHighlight',
    FUNGAL_TO_BACTERIAL_RATIO = 'fungalToBacterialRatio',
    MARINE_SEDIMENT_POLLUTION_INDEX = 'marineSedimentPollutionIndex',
    CHEGD = 'chegd',
    SPECIES_GROUPS = 'speciesGroups',
    TOTAL_SPECIES = 'totalSpecies',
}

export enum FeatureFlagId {
    RISK_INSIGHTS = 'risk-insights',
    NATURE_RISK_SITE_CHARACTERISTICS = 'nature-risk-site-characteristics',
}
